import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { getCourseSubjects, getLevels } from '../../actions/miscellaneousActions'
import { useParams } from 'react-router-dom'
import useAuth from '../../context/auth/useAuth'
import { getScheduledInterviewsBySchool } from '../../actions/choosesActions'
import { getSchool } from '../../actions/schoolsActions'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction"
import '@fullcalendar/bootstrap5/main.css'
import '@fullcalendar/daygrid/main.css'
import esLocale from '@fullcalendar/core/locales/es'
import InterviewSection from '../jitsi/InterviewSection'
import CandidateProfile from '../../pages/admin/CandidateProfile'

export default function SchoolCalendar({visible, setVisible}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const params = useParams()
	const {client} = useAuth()
    
    const calendar = useRef(null)

    const {levels, subjects} = useSelector(state => state.miscellaneous)
    const {schedule} = useSelector(state => state.chooses)
    const {school} = useSelector(state=>state.schools)
    const [isMeetingVisible, setIsMeetingVisible] = useState(false); // Controla si la reunión de Jitsi se muestra

    const [candidateModalShow, setCandidateModalShow] = useState(false);

    const [selectedEvent, setSelectedEvent] = useState(null)
    const [interviewShow, setInterviewShow] = useState(false)

    const capitalizeFirstCharacter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1)
        } else {
            return ''
        }
    }

    const handleEventClick = (e) => {
        if (e.event._def?.extendedProps?.type !== "choose") {
            setSelectedEvent(e.event._def?.extendedProps)
            setInterviewShow(true)
        }
    }

    useEffect(() => {
        if(client && visible){
            dispatch(getSchool(client?.id))
            dispatch(getLevels())
            dispatch(getCourseSubjects())
        }
    // eslint-disable-next-line
    },[dispatch, t, client])

    useEffect(() => {
        if(school){
            dispatch(getScheduledInterviewsBySchool(school._id))
        }
    },[school, dispatch, params.id])

    return (
        <>
            <Modal show={visible} onHide={() => setVisible(false)} size='xl' dialogClassName="modal-90w">
                <Modal.Header closeButton/>
                <Modal.Body>
                    <FullCalendar
                        displayEventTime={false}
                        ref={calendar}
                        height={'auto'}
                        fixedWeekCount={false}
                        locale={esLocale}
                        weekends={true}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        headerToolbar={{
                            start: 'prev',
                            center: 'title',
                            end: 'next',
                        }}
                        events={schedule?.map(s => {
                            let eventDate = new Date(s.day)
                            eventDate.setHours(s.hour?.split(':')[0])
                            eventDate.setMinutes(s.hour?.split(':')[1])
                            return {...s, title: `${s.candidate} (${s.hour})`, start: eventDate, classNames: s.accepted ? 'accepted' : 'pending'}
                        })}
                        eventClick={handleEventClick}
                    />
                </Modal.Body>
            </Modal>
            <Modal show={interviewShow} onHide={() => {setSelectedEvent(null); setInterviewShow(false)}}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedEvent?.selection?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>                    
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("school.selection.candidate")}
                            <small>{selectedEvent?.choose?.candidate?.firstname || ''} {selectedEvent?.choose?.candidate?.lastname || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("school.selection.datetime")}
                            <small>{selectedEvent?.day ? new Date(selectedEvent?.day).toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'}) : ''} {selectedEvent?.hour || ''}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.specialty")}
                            <small>{capitalizeFirstCharacter(levels?.find(l => l.id === selectedEvent?.choose?.selection?.specialty)?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t(selectedEvent?.choose?.selection?.specialty == 1 ? "profile.candidate.position" : "selection.subject")}
                            <small>{t("subjects." + subjects?.find(s => s.id === selectedEvent?.choose?.selection?.subject)?.label)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.shortIncorporationDate")}
                            <small>{`${String(new Date(selectedEvent?.choose?.selection?.incorporationDate).getDate()).padStart(2, '0')}/${String(new Date(selectedEvent?.choose?.selection?.incorporationDate).getMonth() + 1).padStart(2, '0')}/${new Date(selectedEvent?.choose?.selection?.incorporationDate).getFullYear()}`}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.salary")}
                            <small>{selectedEvent?.choose?.selection?.salary || t("selection.byAgreement")}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3 bg-grey'>
                        <div className='d-flex justify-content-between'>
                            {t("selection.contractType")}
                            <small>{t("profile.candidate." + selectedEvent?.choose?.selection?.contractType)}</small>
                        </div>
                    </div>
                    <div className='py-2 px-3'>
                        <div className='d-flex justify-content-between'>
                            {t("profile.candidate.idealPosition.workDay.label")}
                            <small>{t("profile.candidate.idealPosition.workDay." + selectedEvent?.choose?.selection?.workdayType)}</small>
                        </div>
                    </div>
                    {
                        selectedEvent?.day && !(new Date(selectedEvent?.day) < new Date())
                        ?
                            <Row>
                                <Col xs={6} className='mt-4 d-grid gap-2'>
                                    <Button variant="secondary" type="button" onClick={() => {setCandidateModalShow(true)}}>{t("selection.seeCandidate")}</Button>
                                </Col>
                                <Col xs={6} className='mt-4 d-grid gap-2'>
                                    <Button variant="primary" type="button" onClick={() => {setIsMeetingVisible(true); setInterviewShow(false); setVisible(false)}}>{t("selection.openMeeting")}</Button>
                                </Col>
                            </Row>
                        :
                            <div className='mt-4 d-grid gap-2'>
                                <Button variant="secondary" type="button" onClick={() => {setCandidateModalShow(true)}}>{t("selection.seeCandidate")}</Button>
                            </div>
                    }

                </Modal.Body>
            </Modal>
            <Modal show={isMeetingVisible} onHide={() => {setIsMeetingVisible(false)}} fullscreen={true}>
                <Modal.Header closeButton><h4>{t("selection.submenu.interview")}</h4></Modal.Header>
                <Modal.Body>
                    <InterviewSection choose={selectedEvent?.choose} nameSend={school?.name} typeuser={'School'} t={t} />
                </Modal.Body>
            </Modal>
            <Modal show={candidateModalShow} onHide={() => {setCandidateModalShow(false)}} dialogClassName="modal-90w" aria-labelledby="example-custom-modal-styling-title" centered>
                <Modal.Header>
                    <Modal.Title id="example-custom-modal-styling-title" className='w-100 d-flex justify-content-end'>
                        <div>
                            <i className='fa fa-times cursor' onClick={() => setCandidateModalShow(false)}></i>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CandidateProfile candidateToShow={{iduser: selectedEvent?.idUser}} affinity={selectedEvent?.choose?.porcentage} selectedCandidate={selectedEvent?.choose?.candidate} selection={selectedEvent?.choose?.selection?.id}/>
                </Modal.Body>
            </Modal>
        </>
    )
}